/** @type {"initial"} */
export const EXPORT_VIEW_INITIAL = "initial";
/** @type {"saving"} */
export const EXPORT_VIEW_SAVING = "saving";
/** @type {"loading"} */
export const EXPORT_VIEW_LOADING = "loading";
/** @type {"processing"} */
export const EXPORT_VIEW_PROCESSING = "processing";
/** @type {"complete"} */
export const EXPORT_VIEW_COMPLETE = "complete";
/** @type {"error"} */
export const EXPORT_VIEW_ERROR = "error";
